import React, { useEffect, useState } from 'react';
import { MailIcon, SmartphoneIcon, BellIcon, RadioIcon, CheckIcon, AlertTriangleIcon, PhoneCallIcon, GlobeIcon, Share2Icon } from 'lucide-react';
import { ImpactEstimation } from './ImpactEstimation';
export function ChannelSelector() {
  const [pushEnabled, setPushEnabled] = useState(true);
  const [emailEnabled, setEmailEnabled] = useState(false);
  const [smsEnabled, setSmsEnabled] = useState(false);
  const [voiceEnabled, setVoiceEnabled] = useState(false);
  const [websiteEnabled, setWebsiteEnabled] = useState(false);
  const [socialEnabled, setSocialEnabled] = useState(false);
  const [isMultichannel, setIsMultichannel] = useState(false);
  // Derive multichannel state
  useEffect(() => {
    const activeCount = [emailEnabled, smsEnabled, pushEnabled, voiceEnabled, websiteEnabled, socialEnabled].filter(Boolean).length;
    setIsMultichannel(activeCount >= 2);
  }, [emailEnabled, smsEnabled, pushEnabled, voiceEnabled, websiteEnabled, socialEnabled]);
  return <div className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden" data-id="element-1081" data-mp="1owyxxufv13is">
      {/* Header */}
      <div className="p-5 border-b border-slate-50 bg-slate-50/50" data-id="element-1082" data-mp="1tu8m76rij951">
        <div className="flex items-center gap-2 mb-1" data-id="element-1083" data-mp="1ym8sri2390al">
          <h3 className="text-lg font-bold text-[#0F172A] font-heading" data-id="element-1084" data-mp="1yms8cs49nclg">
            Canal de diffusion
          </h3>
        </div>
        <p className="text-sm text-slate-500 font-body" data-id="element-1085" data-mp="15xbahexvn3hu">
          Choisissez comment cet avis sera envoyé aux citoyens.
        </p>
      </div>

      {/* Content */}
      <div className="p-2" data-id="element-1086" data-mp="1awo4qkr2vcug">
        {/* Email Row */}
        <div className="group flex items-center justify-between p-3 rounded-lg hover:bg-[#F8FAFC] transition-colors cursor-pointer" onClick={() => setEmailEnabled(!emailEnabled)} data-id="element-1087" data-mp="1fv97orxpsaml">
          <div className="flex items-center gap-3" data-id="element-1088" data-mp="2raxu9i7237mv">
            <div className={`p-2 rounded-lg transition-colors ${emailEnabled ? 'bg-indigo-50 text-[#4F46E5]' : 'bg-slate-100 text-slate-400 group-hover:bg-white'}`} data-id="element-1089" data-mp="2ra4i21pbvpxc">
              <MailIcon className="w-5 h-5" data-id="element-1090" data-mp="w6q108u2qsc8" />
            </div>
            <span className={`font-medium transition-colors ${emailEnabled ? 'text-[#0F172A]' : 'text-slate-600'}`} data-id="element-1091" data-mp="w9c681thsvra">
              Email
            </span>
          </div>
          <div className={`w-5 h-5 rounded border flex items-center justify-center transition-all duration-200 ${emailEnabled ? 'bg-[#4F46E5] border-[#4F46E5]' : 'bg-white border-slate-300'}`} data-id="element-1092" data-mp="157ehda6xx4sa">
            {emailEnabled && <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-1093" data-mp="chfnn1hswjha" />}
          </div>
        </div>

        {/* SMS Row */}
        <div className="group flex items-center justify-between p-3 rounded-lg hover:bg-[#F8FAFC] transition-colors cursor-pointer" onClick={() => setSmsEnabled(!smsEnabled)} data-id="element-1094" data-mp="8g3x8tr3ru81">
          <div className="flex items-center gap-3" data-id="element-1095" data-mp="hhaex65hnb2v">
            <div className={`p-2 rounded-lg transition-colors ${smsEnabled ? 'bg-indigo-50 text-[#4F46E5]' : 'bg-slate-100 text-slate-400 group-hover:bg-white'}`} data-id="element-1096" data-mp="3pxn1o4g3xmi4">
              <SmartphoneIcon className="w-5 h-5" data-id="element-1097" data-mp="3kxhfh3slws7f" />
            </div>
            <span className={`font-medium transition-colors ${smsEnabled ? 'text-[#0F172A]' : 'text-slate-600'}`} data-id="element-1098" data-mp="20fq8eba2ywbu">
              SMS / SMM
            </span>
          </div>
          <div className={`w-5 h-5 rounded border flex items-center justify-center transition-all duration-200 ${smsEnabled ? 'bg-[#4F46E5] border-[#4F46E5]' : 'bg-white border-slate-300'}`} data-id="element-1099" data-mp="1rhny154girbw">
            {smsEnabled && <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-1100" data-mp="2k6bm18glbut5" />}
          </div>
        </div>

        {/* Voix Automatisée Row */}
        <div className="group flex items-center justify-between p-3 rounded-lg hover:bg-[#F8FAFC] transition-colors cursor-pointer" onClick={() => setVoiceEnabled(!voiceEnabled)} data-id="element-1101" data-mp="2o62kzzg9th8r">
          <div className="flex items-center gap-3" data-id="element-1102" data-mp="2f4w6fvx6mgi5">
            <div className={`p-2 rounded-lg transition-colors ${voiceEnabled ? 'bg-indigo-50 text-[#4F46E5]' : 'bg-slate-100 text-slate-400 group-hover:bg-white'}`} data-id="element-1103" data-mp="ys79iijyjuky">
              <PhoneCallIcon className="w-5 h-5" data-id="element-1104" data-mp="13oxnn0c7cg3q" />
            </div>
            <span className={`font-medium transition-colors ${voiceEnabled ? 'text-[#0F172A]' : 'text-slate-600'}`} data-id="element-1105" data-mp="1j1gv3d339jw4">
              Voix Automatisée
            </span>
          </div>
          <div className={`w-5 h-5 rounded border flex items-center justify-center transition-all duration-200 ${voiceEnabled ? 'bg-[#4F46E5] border-[#4F46E5]' : 'bg-white border-slate-300'}`} data-id="element-1106" data-mp="1a7kc27580nkx">
            {voiceEnabled && <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-1107" data-mp="21yi2t5o11y3r" />}
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-slate-100 mx-3 my-1" data-id="element-1108" data-mp="1xyfysputkslb"></div>

        {/* Push Row */}
        <div className="group flex items-center justify-between p-3 rounded-lg hover:bg-[#F8FAFC] transition-colors cursor-pointer" onClick={() => setPushEnabled(!pushEnabled)} data-id="element-1109" data-mp="1sxsbae5sutvu">
          <div className="flex items-center gap-3" data-id="element-1110" data-mp="hk7phwz28frm">
            <div className={`p-2 rounded-lg transition-colors ${pushEnabled ? 'bg-indigo-50 text-[#4F46E5]' : 'bg-slate-100 text-slate-400 group-hover:bg-white'}`} data-id="element-1111" data-mp="hhlgdswits7a">
              <BellIcon className="w-5 h-5" data-id="element-1112" data-mp="2hptorjgbfgk" />
            </div>
            <div className="flex flex-col" data-id="element-1113" data-mp="7fht06mfe3us">
              <div className="flex items-center gap-2" data-id="element-1114" data-mp="7gj2i6nsmiae">
                <span className={`font-medium transition-colors ${pushEnabled ? 'text-[#0F172A]' : 'text-slate-600'}`} data-id="element-1115" data-mp="cf468g297k3l">
                  Mobile Push
                </span>
                {pushEnabled && <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-[#4F46E5]/10 text-[#4F46E5]" data-id="element-1116" data-mp="l763y6kxuma6">
                    Recommandé
                  </span>}
              </div>
            </div>
          </div>

          {/* Checkbox */}
          <div className={`w-5 h-5 rounded border flex items-center justify-center transition-all duration-200 ${pushEnabled ? 'bg-[#4F46E5] border-[#4F46E5]' : 'bg-white border-slate-300'}`} data-id="element-1117" data-mp="v395ba7yugw2">
            {pushEnabled && <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-1118" data-mp="2wz1nnbzm5kha" />}
          </div>
        </div>

        {/* Site Web Row */}
        <div className="group flex items-center justify-between p-3 rounded-lg hover:bg-[#F8FAFC] transition-colors cursor-pointer" onClick={() => setWebsiteEnabled(!websiteEnabled)} data-id="element-1119" data-mp="2tuu71yyw2kw5">
          <div className="flex items-center gap-3" data-id="element-1120" data-mp="2oydjp6zikak4">
            <div className={`p-2 rounded-lg transition-colors ${websiteEnabled ? 'bg-indigo-50 text-[#4F46E5]' : 'bg-slate-100 text-slate-400 group-hover:bg-white'}`} data-id="element-1121" data-mp="33u1jmjxsubi7">
              <GlobeIcon className="w-5 h-5" data-id="element-1122" data-mp="3ctg85dueoc02" />
            </div>
            <span className={`font-medium transition-colors ${websiteEnabled ? 'text-[#0F172A]' : 'text-slate-600'}`} data-id="element-1123" data-mp="3crvctm09op15">
              Site Web
            </span>
          </div>
          <div className={`w-5 h-5 rounded border flex items-center justify-center transition-all duration-200 ${websiteEnabled ? 'bg-[#4F46E5] border-[#4F46E5]' : 'bg-white border-slate-300'}`} data-id="element-1124" data-mp="3mj868i1prn9a">
            {websiteEnabled && <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-1125" data-mp="3vid3ll1jhajv" />}
          </div>
        </div>

        {/* Réseaux sociaux Row */}
        <div className="group flex items-center justify-between p-3 rounded-lg hover:bg-[#F8FAFC] transition-colors cursor-pointer" onClick={() => setSocialEnabled(!socialEnabled)} data-id="element-1126" data-mp="e1qybmhelwaz">
          <div className="flex items-center gap-3" data-id="element-1127" data-mp="iyhfkd4y2xxz">
            <div className={`p-2 rounded-lg transition-colors ${socialEnabled ? 'bg-indigo-50 text-[#4F46E5]' : 'bg-slate-100 text-slate-400 group-hover:bg-white'}`} data-id="element-1128" data-mp="500z3uha5t2n">
              <Share2Icon className="w-5 h-5" data-id="element-1129" data-mp="3rgx1akyp2cu3" />
            </div>
            <span className={`font-medium transition-colors ${socialEnabled ? 'text-[#0F172A]' : 'text-slate-600'}`} data-id="element-1130" data-mp="3rekb5kis8w5y">
              Réseaux sociaux
            </span>
          </div>
          <div className={`w-5 h-5 rounded border flex items-center justify-center transition-all duration-200 ${socialEnabled ? 'bg-[#4F46E5] border-[#4F46E5]' : 'bg-white border-slate-300'}`} data-id="element-1131" data-mp="3ihjr1q2qxk8b">
            {socialEnabled && <CheckIcon className="w-3.5 h-3.5 text-white" data-id="element-1132" data-mp="38ikpergeeout" />}
          </div>
        </div>

        {/* Warning Message */}
        {!pushEnabled && <div className="mx-3 mt-1 mb-2 p-2 bg-amber-50 rounded border border-amber-100 flex items-start gap-2 animate-in fade-in slide-in-from-top-1 duration-200" data-id="element-1133" data-mp="3syndmqx7jrus">
            <AlertTriangleIcon className="w-4 h-4 text-amber-500 mt-0.5 flex-shrink-0" data-id="element-1134" data-mp="3nxprk392udo0" />
            <p className="text-xs text-amber-700" data-id="element-1135" data-mp="3jwe3411xvyhe">
              Le mobile push génère le meilleur taux d'engagement.
            </p>
          </div>}

        {/* Multicanal Row (Auto-detected) */}
        <div className={`group flex items-center justify-between p-3 rounded-lg transition-all duration-300 ${isMultichannel ? 'bg-indigo-50/30' : 'opacity-50 grayscale'}`} data-id="element-1136" data-mp="3a1cbmyk6ykbn">
          <div className="flex items-center gap-3" data-id="element-1137" data-mp="30b9i8x95r4cs">
            <div className={`p-2 rounded-lg transition-colors ${isMultichannel ? 'bg-indigo-100 text-[#4F46E5]' : 'bg-slate-100 text-slate-400'}`} data-id="element-1138" data-mp="2w8mqewchljfl">
              <RadioIcon className="w-5 h-5" data-id="element-1139" data-mp="2r88gf8rbrzex" />
            </div>
            <div className="flex flex-col gap-0.5" data-id="element-1140" data-mp="2maqcxxw2uceb">
              <div className="flex items-center gap-2" data-id="element-1141" data-mp="2mb8khqo6wd1j">
                <span className={`font-medium transition-colors ${isMultichannel ? 'text-[#0F172A]' : 'text-slate-500'}`} data-id="element-1142" data-mp="11t7hyv1unhsv">
                  Multicanal
                </span>
                {isMultichannel && <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-bold bg-[#4F46E5] text-white shadow-sm" data-id="element-1143" data-mp="1bq2h9g5y5m87">
                    ACTIVÉ
                  </span>}
              </div>
              {isMultichannel && <span className="text-xs text-slate-400 font-body" data-id="element-1144" data-mp="j380at8c94zh">
                  Envoi simultané sur les canaux sélectionnés.
                </span>}
              <span className="text-[11px] text-slate-400/70 font-body select-none" data-id="element-1145" data-mp="s2v0xct8u6rh">
                🤖 Séquencement intelligent (à venir)
              </span>
            </div>
          </div>

          {/* Visual indicator only, not interactive */}
          <div className={`w-3 h-3 rounded-full transition-colors flex-shrink-0 ${isMultichannel ? 'bg-[#4F46E5]' : 'bg-slate-300'}`} data-id="element-1146" data-mp="axao12p33jb"></div>
        </div>
      </div>

      {/* Footer Stats */}
      <div className="px-5 pb-5" data-id="element-1147" data-mp="1bk4ebfky761r">
        <ImpactEstimation data-id="element-1148" data-mp="1bn8oqup0ay0v" />
      </div>
    </div>;
}